import api from "../api";

const submitVolunteer = async (formData) => {
    try {
        const response = await api.post("/volunteers", formData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Getting approved volunteers (public)
const getApprovedVolunteers = async () => {
    try {
        const response = await api.get("/volunteers/public");
        const data = Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
        return data;
    } catch (error) {
        console.error("Error fetching approved volunteers:", error.response?.status, error.response?.data || error.message);
        throw error;
    }
};

export { submitVolunteer, getApprovedVolunteers };